import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomPayOptionsPage } from '../custom-pay-options/custom-pay-options.page';
import { IonNav } from '@ionic/angular';
import { CommonService } from 'src/app/services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-amount',
  templateUrl: './custom-amount.page.html',
  styleUrls: ['./custom-amount.page.scss'],
})
export class CustomAmountPage implements OnInit {
  @Input() caseData;
  @Input() planType = 'plan';
  @Input() total = 0;
  @Input() caseList = [];
  customAmountForm: FormGroup;
  minLimitMessage = '';
  maxLimitMessage = '';
  constructor(private formBuilder:FormBuilder, private ionNav: IonNav, private commonService: CommonService, private translate: TranslateService) { }

  ngOnInit() {
    this.initForm();
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (localStorage.getItem('language') != 'en') {
      this.minLimitMessage = portalSettings['payment_amount_limit_min_message_' + localStorage.getItem('language')] ||  portalSettings?.payment_amount_limit_min_message;
      this.maxLimitMessage = portalSettings['payment_amount_limit_exceed_message_' + localStorage.getItem('language')] ||  portalSettings?.payment_amount_limit_exceed_message;
    } else {
      this.minLimitMessage = portalSettings?.payment_amount_limit_min_message;
      this.maxLimitMessage = portalSettings?.payment_amount_limit_exceed_message;
    }
    if (this.minLimitMessage == '') {
      this.minLimitMessage = this.translate.instant('PAYMENT.AMOUNT_NOT_LESS_THAN', {amount: portalSettings.payment_amount_limit_min})
    }
    if (this.maxLimitMessage == '') {
      this.maxLimitMessage = this.translate.instant('PAYMENT.AMOUNT_NOT_GREATER_THAN', {amount: portalSettings.payment_amount_limit_exceed})
    }
  }
  initForm() {
    this.customAmountForm = this.formBuilder.group({
      amount: ['',[Validators.required,Validators.pattern('^[1-9][0-9]*$')]]
    });
  }
  save(){
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (portalSettings?.payment_amount_limit_min && this.customAmountForm.value < parseFloat(portalSettings.payment_amount_limit_min)) {
      this.commonService.showToast(this.minLimitMessage, 'danger');
      return;
    }
    if (portalSettings?.payment_amount_limit_exceed && this.customAmountForm.value > parseFloat(portalSettings.payment_amount_limit_exceed)) {
      this.commonService.showToast(this.maxLimitMessage, 'danger');
      return;
    }
    this.customAmountForm.markAllAsTouched();
    if(this.customAmountForm.valid){
      this.ionNav.push(CustomPayOptionsPage, { amount:this.customAmountForm.value.amount,caseData:this.caseData, planType: this.planType, total: this.total, caseList:this.caseList });
  }
  else{
    this.commonService.showToast(this.translate.instant('PAYMENT.INVALID_AMOUNT'), 'danger');
  }
}

}
